<template>
  <vx-card no-shadow>

    <h2 class="mb-6">Address</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Address</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <gmap-autocomplete class="addressInput vs-inputx vs-input--input normal" placeholder="Address..." @place_changed="updateAddress">
          <template v-slot:input="slotProps">
            <v-text-field outlined
                          prepend-inner-icon="place"
                          placeholder="Address"
                          ref="input"
                          v-on:listeners="slotProps.listeners"
                          v-on:attrs="slotProps.attrs">
            </v-text-field>
          </template>
      </gmap-autocomplete>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Street</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="street" readonly disabled />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>City</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="city" readonly disabled />
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Postal Code</span>
      </div>
      <div class="vx-col sm:w-1/5 w-full">
        <vs-input class="w-full" v-model="postalCode" readonly disabled />
      </div>
    </div>
    <div class="vx-row mb-12">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Country</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="country" readonly disabled />
      </div>
    </div>

    <gmap-map :center="center" :zoom="15" style="width: 100%; height: 500px">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        
      </gmap-info-window>
      <gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position" :clickable="true" @click="toggleInfoWindow(m,i)"></gmap-marker>
    </gmap-map>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveAddress" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<style scoped>  
.addressInput {
  width: 100%;
}
</style>

<script>
export default {
  props: {
    venueTrainingInstance: Object
  },
  data() {
    return {
      street: '',
      city: '',
      postalCode: '',
      country: '',

      center: { lat: 55.680897, lng: 12.575954 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
      pixelOffset: { width: 0, height: -35 }
      },
      markers: [
        { position: { lat: 55.680897, lng: 12.575954 }, infoText: '' }
      ]
    }
  },
  created() {
    this.getAddress();
  },
  methods: {
    getAddress: function () {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/VenueTraining/' + this.venueTrainingInstance.id + '/info/address')
          .then(resp => {
            this.street = resp.data.street;
            this.city = resp.data.city;
            this.postalCode = resp.data.postalCode;
            this.country = resp.data.country;

            var location = {
              lat: resp.data.latitude,
              lng: resp.data.longitude
            }

            this.center = location;
            this.markers[0].position = location;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    updateAddress: function(payload) {
      const lat = payload.geometry.location.lat()
      const lng = payload.geometry.location.lng()

      this.center.lat = lat
      this.center.lng = lng
      
      this.markers[0].position.lat = lat
      this.markers[0].position.lng = lng

      this.street = this.getAddressComponent(payload, 'route') + ' ' + this.getAddressComponent(payload, 'street_number')
      this.city = this.getAddressComponent(payload, 'locality')
      this.postalCode = this.getAddressComponent(payload, 'postal_code')
      this.country = this.getAddressComponent(payload, 'country')
    },

    getAddressComponent: function(address, component) {
      var result = address.address_components.filter((cmp) => {

        if(cmp.types.includes(component)) {
          return true;
        }
        
        return false;
      })

      if (result.length == 0) {
        return ''
      }

      return result[0].long_name
    },

    saveAddress: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      const payload = {
        street: this.street,
        city: this.city,
        postalCode: this.postalCode,
        country: this.country,

        latitude: this.center.lat,
        longitude: this.center.lng
      }

      this.$http.post(process.env.VUE_APP_API + '/VenueTraining/' + this.venueTrainingInstance.id + '/info/address', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Event Address saved'
            });
          })
          .catch(err => {
            console.log(err);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save Event Address: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
}
</script>
